// ===== CSS (Vite extracts into separate .css file) =====

// Vendor CSS
import '../../../../../components/mediaelement/build/mediaelementplayer.min.css';
import '../../../../../components/normalize-css/normalize.css';
import '../../../../../components/font-awesome/css/font-awesome.min.css';
import '../../../../../components/ekko-lightbox/dist/ekko-lightbox.css';
import '../../../../../components/seiyria-bootstrap-slider/dist/css/bootstrap-slider.min.css';
import '../../../../../components/owl.carousel/dist/assets/owl.carousel.min.css';
import '../../../../../components/owl.carousel/dist/assets/owl.theme.default.min.css';

// Bootstrap LESS
import '../../../../../components/bootstrap/less/bootstrap_modified.less';

// App LESS
import '../less/app/style_catalog.less';

// Date picker (flatpickr) CSS — imported directly here (not only transitively via
// flatpickr-init.js) so the lessSourcemapPlugin in vite.config.js, which rebuilds the
// bundle CSS from this entry's DIRECT css/less imports, includes it. Kept after the app
// LESS so flatpickr-overrides.css still wins over form.less.
import '../../../../../node_modules/flatpickr/dist/flatpickr.css';
import '../../../../shared/css/flatpickr-overrides.css';

// ===== JS =====

// Vendor JS (catalog subset)
import '../../../../../components/jquery/jquery.min.js';
import '../../../../../components/jquery-hoverIntent/jquery.hoverIntent.js';
import '../../../../../components/ekko-lightbox/dist/ekko-lightbox.min.js';
import '../../../../../components/bxslider/jquery.bxslider-rahisified.min.js';
import '../../../../../components/seiyria-bootstrap-slider/dist/bootstrap-slider.min.js';
import '../../../../../components/owl.carousel/dist/owl.carousel.min.js';
import '../../../../../components/password-strength-meter/dist/password.min.js';
import '../../../../../components/isotope/dist/isotope.pkgd.js';
import '../../../../../components/jsvat/dist/jsvat.js';

// Bootstrap JS (selected modules)
import '../../../../../components/bootstrap/js/affix.js';
import '../../../../../components/bootstrap/js/alert.js';
import '../../../../../components/bootstrap/js/button.js';
import '../../../../../components/bootstrap/js/modal.js';
import '../../../../../components/bootstrap/js/tooltip.js';
import '../../../../../components/bootstrap/js/transition.js';

// Core shared code
import '../../../../../dc/common/common.js';
import '../../../../../module/dcshop/common/dc_functions.js';

// Date pickers (flatpickr) — shared init across admin + all shops
import '../../../../shared/js/flatpickr-init.js';

// Main catalog script
import './script_catalog.js';

// dotLottie animations
import { initLottieAnimations } from './modules/lottie-player.js';
document.addEventListener('DOMContentLoaded', initLottieAnimations);

// Globals bridge
import './globals.js';
